import { render, staticRenderFns } from "./batchAudit.vue?vue&type=template&id=2fb29cfb&scoped=true"
import script from "./batchAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./batchAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb29cfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb29cfb')) {
      api.createRecord('2fb29cfb', component.options)
    } else {
      api.reload('2fb29cfb', component.options)
    }
    module.hot.accept("./batchAudit.vue?vue&type=template&id=2fb29cfb&scoped=true", function () {
      api.rerender('2fb29cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/batchAudit.vue"
export default component.exports